/* Mini cart (header cart panel): instant quantity changes, remove and undo, kept in step with the cart page.
   Lives in its own asset because sections/header.liquid is at Shopify's 256 KB section limit. */
(function miniCart() {
  function withImageWidth(url, width) {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (e) {
      const source = String(url);
      const separator = source.indexOf('?') === -1 ? '?' : '&';
      return `${source}${separator}width=${encodeURIComponent(String(width))}`;
    }
  }

  (function miniCartAjaxRemove() {
    const cartPanel = document.querySelector('[data-mini-cart]');
    if (!cartPanel) return;

    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.',
    ) {
      const num = Number(number);
      if (Number.isNaN(num)) return '';
      const fixed = num.toFixed(precision);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    function stripTags(input) {
      return String(input || '').replace(/<[^>]*>/g, '');
    }

    function decodeEntities(input) {
      const txt = document.createElement('textarea');
      txt.innerHTML = String(input || '');
      return txt.value;
    }

    window.MegaMacCart = window.MegaMacCart || {};

    function createSessionVariantStore(storageKey) {
      return {
        key: storageKey,
        get: function get(variantId) {
          if (!variantId) return '';
          try {
            const raw = sessionStorage.getItem(storageKey);
            if (!raw) return '';
            const map = JSON.parse(raw);
            if (!map || typeof map !== 'object') return '';
            const value = map[String(variantId)];
            return value ? String(value) : '';
          } catch (_) {
            return '';
          }
        },
        set: function set(variantId, value) {
          if (!variantId || !value) return;
          try {
            const id = String(variantId);
            const nextValue = String(value);
            const raw = sessionStorage.getItem(storageKey);
            let map = {};
            if (raw) {
              try {
                const parsed = JSON.parse(raw);
                if (parsed && typeof parsed === 'object') map = parsed;
              } catch (_) {}
            }
            map[id] = nextValue;
            sessionStorage.setItem(storageKey, JSON.stringify(map));
          } catch (_) {}
        },
      };
    }

    if (!window.MegaMacCart.cartImageStore) {
      window.MegaMacCart.cartImageStore = createSessionVariantStore(
        'mm:cart-image-by-variant',
      );
      // Stock caps by variant, handed over by the product page at add time and learned from Shopify's refusals,
      // so rows this script draws from cart JSON (which carries no stock) still stop at the stock.
      window.MegaMacCart.cartMaxQtyStore =
        window.MegaMacCart.cartMaxQtyStore ||
        createSessionVariantStore('mm:cart-max-qty-by-variant');
    }
    window.MegaMacCart.hoverImageStore = window.MegaMacCart.cartImageStore;

    const cartImageStore = window.MegaMacCart.cartImageStore;
    const cartMaxQtyStore = window.MegaMacCart.cartMaxQtyStore; // stock caps by variant, see above

    // The last cart the panel rendered. Quantity changes and removals are laid over it to update the totals
    // straight away, before Shopify replies.
    let lastKnownCart = null;
    try {
      const initialCartEl = document.querySelector('[data-mini-cart-initial]');
      lastKnownCart = initialCartEl
        ? JSON.parse(initialCartEl.textContent || 'null')
        : null;
    } catch (_) {}

    function getMiniCartImageSources(url) {
      if (!url) {
        return {
          src: '',
          srcset: '',
          sizes: '120px',
        };
      }

      return {
        src: withImageWidth(url, 360),
        srcset: [
          `${withImageWidth(url, 240)} 240w`,
          `${withImageWidth(url, 480)} 480w`,
          `${withImageWidth(url, 720)} 720w`,
        ].join(', '),
        sizes: '240px',
      };
    }

    function applyMiniCartItemImage(img, url, alt, options) {
      if (!img) return;
      if (!url) {
        img.remove();
        return;
      }

      const useCachedUrl = !!(options && options.useCachedUrl);
      img.setAttribute('alt', alt || '');
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
      img.setAttribute(
        'fetchpriority',
        (options && options.fetchpriority) || 'auto',
      );

      if (useCachedUrl) {
        img.setAttribute('src', url);
        img.removeAttribute('srcset');
        img.setAttribute('sizes', '120px');
        return;
      }

      const imageSources = getMiniCartImageSources(url);
      img.setAttribute('src', imageSources.src);
      img.setAttribute('srcset', imageSources.srcset);
      img.setAttribute('sizes', imageSources.sizes);
    }

    function formatMoney(cents, moneyFormat) {
      const formatString = moneyFormat || '';
      const placeholderRegex = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
      const match = formatString.match(placeholderRegex);
      const placeholder = match ? match[1] : null;

      const centsNumber =
        typeof cents === 'string'
          ? Number(cents.replace('.', ''))
          : Number(cents);
      const valueCents = Number.isNaN(centsNumber) ? 0 : centsNumber;

      // Prefer Intl for correct currency symbols AND drop trailing zeros
      // (match Liquid's money_without_trailing_zeros behavior).
      if (typeof Intl !== 'undefined' && currencyCode) {
        try {
          const base = new Intl.NumberFormat(locale || undefined, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'narrowSymbol',
          });

          const maxDigits = base.resolvedOptions().maximumFractionDigits;
          const factor = Math.pow(10, maxDigits);
          const isWhole = maxDigits === 0 ? true : valueCents % factor === 0;

          const fmt = new Intl.NumberFormat(locale || undefined, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: isWhole ? 0 : maxDigits,
            maximumFractionDigits: maxDigits,
          });

          return fmt.format(valueCents / 100);
        } catch (_) {
          // fall through to moneyFormat handling
        }
      }

      // If we don't have a Shopify-style placeholder format string, fall back to a simple number.
      if (!placeholder) return formatWithDelimiters(valueCents / 100, 2);

      let value = '';
      switch (placeholder) {
        case 'amount':
          value = formatWithDelimiters(valueCents / 100, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(valueCents / 100, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(valueCents / 100, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(valueCents / 100, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(valueCents / 100, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(valueCents / 100, 2);
      }

      // moneyFormat may include HTML entities/tags; we render into textContent, so strip/decode.
      const raw = formatString.replace(placeholderRegex, value);
      return decodeEntities(stripTags(raw));
    }

    const moneyFormat =
      window.MegaMacCart.safeJsonParse(cartPanel.dataset.moneyFormat, null) ||
      '';
    const currencyCode = cartPanel.dataset.currencyCode || '';
    const locale =
      cartPanel.dataset.locale || document.documentElement.lang || '';

    // Shared with the search panel so both render prices in the active market's currency.
    window.MegaMacCart.formatMoney = function formatMoneyInCartCurrency(cents) {
      return formatMoney(cents, moneyFormat);
    };

    cartPanel
      .querySelectorAll('[data-mini-cart-price-cents]')
      .forEach(function formatInitialItemPrice(priceEl) {
        const cents = Number(
          priceEl.getAttribute('data-mini-cart-price-cents'),
        );
        if (!Number.isFinite(cents)) return;
        priceEl.textContent = formatMoney(cents, moneyFormat);
      });

    const cartTitle = cartPanel.dataset.cartTitle || 'Cart';
    const checkoutLabel = cartPanel.dataset.cartCheckoutLabel || 'Checkout';
    const cartChangeUrl = cartPanel.dataset.cartChangeUrl || '/cart/change';
    const freeShipEnabled =
      window.MegaMacCart.safeJsonParse(
        cartPanel.dataset.freeShipEnabled,
        null,
      ) === true;
    const freeShipThresholdCents = Number(
      cartPanel.dataset.freeShipThresholdCents || 0,
    );
    const freeShipFreeMessage = cartPanel.dataset.freeShipFreeMessage || '';
    const freeShipLeftMessage = cartPanel.dataset.freeShipLeftMessage || '';
    const freeShipThresholdMessage =
      cartPanel.dataset.freeShipThresholdMessage || '';

    function updateTitle(count) {
      const titleEl = cartPanel.querySelector(
        '.header__icons__panel__cart__content__title',
      );
      if (!titleEl) return;
      titleEl.textContent = count > 0 ? `${cartTitle} (${count})` : cartTitle;
    }

    function ensureEmptyState(isEmpty) {
      const existingEmpty = cartPanel.querySelector(
        '.header__icons__panel__cart__content__empty',
      );
      const itemsContainer = cartPanel.querySelector(
        '.header__icons__panel__cart__content__items',
      );

      if (isEmpty) {
        if (!existingEmpty) {
          const emptyEl = document.createElement('h3');
          emptyEl.className = 'header__icons__panel__cart__content__empty';
          emptyEl.textContent =
            cartPanel.dataset.cartEmptyTitle || 'Your cart is empty';
          if (itemsContainer) itemsContainer.appendChild(emptyEl);
        }
      } else if (existingEmpty) {
        existingEmpty.remove();
      }
    }

    function updateSubtotal(cents) {
      const subtotalEl = cartPanel.querySelector('[data-mini-cart-subtotal]');
      if (!subtotalEl) return;
      subtotalEl.textContent = formatMoney(cents, moneyFormat);
    }

    function updateTaxPill(count) {
      const el = cartPanel.querySelector('[data-mini-cart-tax-pill]');
      if (!el) return;
      el.hidden = count <= 0;
    }

    function updateCheckoutButton(count) {
      const wrapper = cartPanel.querySelector(
        '.header__icons__panel__cart__content__btns-wrapper',
      );
      if (!wrapper) return;

      const existingForm = wrapper.querySelector('form');
      const existingButton = wrapper.querySelector(
        '.header__icons__panel__cart__content__checkout-btn',
      );
      const viewCartLink = wrapper.querySelector(
        '.header__icons__panel__cart__content__view-btn',
      );
      const cartUrl =
        (viewCartLink && viewCartLink.getAttribute('href')) || '/cart';

      if (count > 0) {
        if (existingForm) return;

        if (existingButton) existingButton.remove();
        const form = document.createElement('form');
        form.action = cartUrl;
        form.method = 'post';

        const btn = document.createElement('button');
        // Match Liquid non-empty cart styling (gradient CTA)
        btn.className = 'header-CTA';
        btn.type = 'submit';
        btn.name = 'checkout';
        btn.textContent = checkoutLabel;

        form.appendChild(btn);
        wrapper.insertBefore(form, wrapper.firstChild);
      } else {
        if (existingForm) existingForm.remove();
        if (existingButton) {
          existingButton.disabled = true;
          existingButton.setAttribute('aria-disabled', 'true');
          existingButton.textContent = checkoutLabel;
        } else {
          const btn = document.createElement('button');
          btn.className = 'header__icons__panel__cart__content__checkout-btn';
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = checkoutLabel;
          wrapper.insertBefore(btn, wrapper.firstChild);
        }
      }
    }

    function shippingFromSentence() {
      const minCents = Number(cartPanel.dataset.shippingMinCents || 0);
      if (minCents <= 0) return '';
      const tpl = cartPanel.dataset.shippingFromTemplate || '';
      if (!tpl) return '';
      return tpl.replace('__AMOUNT__', formatMoney(minCents, moneyFormat));
    }

    function composeProgressMessage(cartTotalCents, itemCount) {
      const show = freeShipEnabled && freeShipThresholdCents > 0;
      if (!show) return '';

      if (itemCount <= 0) return freeShipThresholdMessage;

      const remaining = freeShipThresholdCents - cartTotalCents;
      if (remaining <= 0) return freeShipFreeMessage;

      return freeShipLeftMessage.replace(
        '__AMOUNT__',
        formatMoney(remaining, moneyFormat),
      );
    }

    function composeSubtotalShippingNote(cartTotalCents) {
      const show = freeShipEnabled && freeShipThresholdCents > 0;
      if (show && cartTotalCents >= freeShipThresholdCents) return '';

      const from = shippingFromSentence();
      if (from) return `${from}.`;
      const checkout = cartPanel.dataset.shippingCheckout || '';
      return checkout ? `${checkout}.` : '';
    }

    function updateFreeShipping(cartTotalCents, itemCount) {
      const infoEl = cartPanel.querySelector(
        '.header__icons__panel__cart__content__info',
      );
      if (!infoEl) return;

      const show = freeShipEnabled && freeShipThresholdCents > 0;
      const remaining = show ? freeShipThresholdCents - cartTotalCents : 0;
      const pct = !show
        ? 0
        : remaining <= 0
          ? 100
          : Math.min(
              100,
              Math.floor((cartTotalCents * 100) / freeShipThresholdCents),
            );

      infoEl.textContent = decodeEntities(
        stripTags(composeProgressMessage(cartTotalCents, itemCount)),
      );

      const fromEl = cartPanel.querySelector('[data-mini-cart-shipping-from]');
      if (fromEl) {
        fromEl.textContent = decodeEntities(
          stripTags(composeSubtotalShippingNote(cartTotalCents)),
        );
      }

      // Only show progress bar while there's still an amount left to reach free shipping
      const existing = cartPanel.querySelector(
        '.header__icons__panel__cart__content__shipping-progress',
      );
      if (!show || itemCount <= 0 || remaining <= 0) {
        if (existing) existing.remove();
        return;
      }

      const progressEl =
        existing ||
        (function createProgress() {
          const el = document.createElement('div');
          el.className =
            'header__icons__panel__cart__content__shipping-progress';
          el.setAttribute('role', 'progressbar');
          el.setAttribute('aria-valuemin', '0');
          el.setAttribute('aria-valuemax', '100');
          el.setAttribute('aria-label', 'Free shipping progress');

          const bar = document.createElement('div');
          bar.className =
            'header__icons__panel__cart__content__shipping-progress__bar';
          el.appendChild(bar);

          infoEl.insertAdjacentElement('afterend', el);
          return el;
        })();

      progressEl.setAttribute('aria-valuenow', String(pct));
      const bar = progressEl.querySelector(
        '.header__icons__panel__cart__content__shipping-progress__bar',
      );
      if (bar) bar.style.width = `${pct}%`;
    }

    function getItemRows(itemsContainer) {
      if (!itemsContainer) return [];
      return Array.from(itemsContainer.children).filter(function (child) {
        return child.classList.contains(
          'header__icons__panel__cart__content__item',
        );
      });
    }

    function getItemRowKey(row) {
      const keyedElement = row.querySelector('[data-cart-line-key]');
      return keyedElement
        ? keyedElement.getAttribute('data-cart-line-key') || ''
        : '';
    }

    function captureItemRowPositions(itemsContainer, excludedRow) {
      const positions = new Map();
      getItemRows(itemsContainer).forEach(function captureRow(row, index) {
        if (row === excludedRow) return;
        const lineKey = getItemRowKey(row);
        if (!lineKey) return;
        const bounds = row.getBoundingClientRect();
        positions.set(lineKey, {
          row: row,
          index: index,
          top: bounds.top,
          height: bounds.height,
        });
      });
      return positions;
    }

    const stackPositionAnimations = new WeakMap();

    function animateStackPositionChange(element, previousTop) {
      const previousAnimation = stackPositionAnimations.get(element);
      if (previousAnimation) {
        stackPositionAnimations.delete(element);
        previousAnimation.cancel();
      }
      const delta = previousTop - element.getBoundingClientRect().top;
      if (delta === 0) return;
      const animation = element.animate(
        [{ translate: `0 ${delta}px` }, { translate: '0 0' }],
        {
          duration: STACK_REPOSITION_ANIMATION_MS,
          easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
        },
      );
      stackPositionAnimations.set(element, animation);
      function clearStackPositionAnimation() {
        if (stackPositionAnimations.get(element) === animation) {
          stackPositionAnimations.delete(element);
        }
      }
      animation.finished.then(
        clearStackPositionAnimation,
        clearStackPositionAnimation,
      );
    }

    function animateItemRowPositionChanges(positions) {
      positions.forEach(function animatePositionChange(position, lineKey) {
        const row = position.row;
        if (!row.isConnected || getItemRowKey(row) !== lineKey) return;
        animateStackPositionChange(row, position.top);
      });
    }

    function reconcileItems(cart) {
      const firstCol = cartPanel.firstElementChild;
      if (!firstCol) return;

      const items = (cart && Array.isArray(cart.items) && cart.items) || [];
      const count =
        (cart && typeof cart.item_count === 'number' && cart.item_count) ||
        items.length ||
        0;

      let itemsContainer = cartPanel.querySelector(
        '.header__icons__panel__cart__content__items',
      );

      if (count <= 0) {
        getItemRows(itemsContainer).forEach(function removeRow(row) {
          row.remove();
        });
        ensureEmptyState(true);
        return;
      }

      ensureEmptyState(false);

      if (!itemsContainer) {
        itemsContainer = document.createElement('div');
        itemsContainer.className = 'header__icons__panel__cart__content__items';

        const titleEl = cartPanel.querySelector(
          '.header__icons__panel__cart__content__title',
        );
        if (titleEl) {
          titleEl.insertAdjacentElement('afterend', itemsContainer);
        } else {
          firstCol.appendChild(itemsContainer);
        }
      }

      const tmpl = cartPanel.querySelector(
        'template[data-mini-cart-item-template]',
      );
      if (!tmpl || !tmpl.content || !tmpl.content.firstElementChild) return;

      const removeLabel = cartPanel.dataset.cartRemoveLabel || 'Remove';
      const undoTemplate = cartPanel.dataset.cartUndoRemovedTemplate || '';

      // Build a map of existing DOM items by line key so we can preserve existing imagery/markup.
      const existing = new Map();
      const existingEls = itemsContainer.querySelectorAll(
        '.header__icons__panel__cart__content__item',
      );
      existingEls.forEach(function (el) {
        const btn = el.querySelector('[data-cart-line-key]');
        const key = btn ? btn.getAttribute('data-cart-line-key') : '';
        if (key) existing.set(key, el);
      });

      const nodes = [];

      items.forEach(function (item, index) {
        const key = item.key || '';
        if (!key) return;

        const fallbackTitle = item.product_title || item.title || '';
        const url = item.url || '';
        const variantId = item.variant_id ? String(item.variant_id) : '';
        const displayTitle = fallbackTitle;

        let node = existing.get(key) || removedRows.get(key);
        if (node) {
          const titleEl = node.querySelector('[data-mini-cart-item-title]');
          if (titleEl) titleEl.textContent = displayTitle;

          const storedImgUrl = cartImageStore
            ? cartImageStore.get(variantId)
            : '';
          if (storedImgUrl) {
            const img = node.querySelector('[data-mini-cart-item-img]');
            const imgAlt =
              (item.featured_image && item.featured_image.alt) ||
              displayTitle ||
              cartPanel.dataset.cartTitle ||
              'Cart';
            applyMiniCartItemImage(img, storedImgUrl, imgAlt, {
              useCachedUrl: true,
              fetchpriority: index === 0 ? 'high' : 'auto',
            });
          }
        } else {
          node = tmpl.content.firstElementChild.cloneNode(true);

          const titleEl = node.querySelector('[data-mini-cart-item-title]');
          if (titleEl) titleEl.textContent = displayTitle;

          const img = node.querySelector('[data-mini-cart-item-img]');
          const storedImgUrl = cartImageStore
            ? cartImageStore.get(variantId)
            : '';
          const featuredImgUrl =
            item.featured_image && item.featured_image.url
              ? item.featured_image.url
              : '';
          const imgUrl = storedImgUrl || featuredImgUrl;
          const imgAlt =
            (item.featured_image && item.featured_image.alt) ||
            displayTitle ||
            cartPanel.dataset.cartTitle ||
            'Cart';

          if (img && imgUrl) {
            applyMiniCartItemImage(img, imgUrl, imgAlt, {
              useCachedUrl: !!storedImgUrl,
              fetchpriority: index === 0 ? 'high' : 'auto',
            });
          } else if (img) {
            img.remove();
          }
        }

        const priceEl = node.querySelector('[data-mini-cart-item-price]');
        if (priceEl)
          priceEl.textContent = formatMoney(item.final_price || 0, moneyFormat);

        // Two links per row: the picture (labelled, as it has no text) and the title.
        node
          .querySelectorAll('[data-mini-cart-item-link]')
          .forEach(function (itemLink) {
            if (url) itemLink.setAttribute('href', url);
            if (!itemLink.hasAttribute('data-mini-cart-item-title'))
              itemLink.setAttribute('aria-label', displayTitle);
          });

        const quantity = item.quantity || 1;
        const quantityInput = node.querySelector(
          '[data-mini-cart-quantity-input]',
        );
        if (quantityInput) {
          quantityInput.value = String(quantity);
          quantityInput.setAttribute('data-cart-line-key', key);
          quantityInput.setAttribute(
            'data-cart-quantity-baseline',
            String(quantity),
          );
          quantityInput.setAttribute(
            'aria-label',
            `Quantity for ${displayTitle}`,
          );
          // A row drawn from cart JSON has no cap of its own; use the one the add handed over, if any.
          if (!quantityInput.hasAttribute('max') && cartMaxQtyStore) {
            const knownMax = parseInt(cartMaxQtyStore.get(variantId) || '', 10);
            if (Number.isFinite(knownMax) && knownMax > 0) {
              quantityInput.setAttribute('max', String(knownMax));
              quantityInput.setAttribute('data-cart-stock-limited', 'true');
            }
          }
          syncIncrementButton(quantityInput);
        }

        const decrementBtn = node.querySelector(
          '[data-mini-cart-quantity-decrement]',
        );
        if (decrementBtn)
          decrementBtn.setAttribute(
            'aria-label',
            `Decrease quantity for ${displayTitle}`,
          );

        const incrementBtn = node.querySelector(
          '[data-mini-cart-quantity-increment]',
        );
        if (incrementBtn)
          incrementBtn.setAttribute(
            'aria-label',
            `Increase quantity for ${displayTitle}`,
          );

        const removeBtn = node.querySelector('[data-cart-remove-ajax]');
        if (removeBtn) {
          const undoMsg = undoTemplate
            ? undoTemplate.replace('__ITEM__', fallbackTitle)
            : '';

          removeBtn.setAttribute(
            'aria-label',
            `${removeLabel} – ${displayTitle}`,
          );
          removeBtn.setAttribute(
            'href',
            `${cartChangeUrl}?id=${encodeURIComponent(key)}&quantity=0`,
          );
          removeBtn.setAttribute('data-cart-line-key', key);
          removeBtn.setAttribute('data-cart-variant-id', variantId);
          removeBtn.setAttribute('data-cart-quantity', String(quantity));
          removeBtn.setAttribute('data-cart-undo-message', undoMsg);
        }

        nodes.push(node);
      });

      // Existing rows were updated in place above. Only re-append when lines were added, removed or reordered,
      // because moving a row drops focus from its quantity buttons mid-click.
      const current = getItemRows(itemsContainer);
      const unchanged =
        current.length === nodes.length &&
        nodes.every(function sameRow(node, index) {
          return current[index] === node;
        });
      if (unchanged) return;

      current.forEach(function removeRow(node) {
        if (!nodes.includes(node)) node.remove();
      });
      nodes.forEach(function appendRow(node) {
        itemsContainer.appendChild(node);
      });
    }

    function updateCartIconButtons(count) {
      const buttons = document.querySelectorAll(
        'button[data-panel-button="cart"], button[data-mobile-icon-button="cart"]',
      );
      if (!buttons.length) return;

      const safeCount =
        typeof count === 'number'
          ? count
          : parseInt(String(count || '0'), 10) || 0;
      const label =
        safeCount > 0
          ? `Shopping cart, ${safeCount} item${safeCount === 1 ? '' : 's'}`
          : 'Shopping cart';

      buttons.forEach(btn => {
        btn.setAttribute('aria-label', label);

        const filled = btn.querySelector('[data-cart-icon="filled"]');
        const empty = btn.querySelector('[data-cart-icon="empty"]');

        if (filled) filled.hidden = safeCount <= 0;
        if (empty) empty.hidden = safeCount > 0;
      });
    }

    // Quantities the shopper has picked but Shopify hasn't confirmed yet (keyed by line key), and lines they've
    // removed that are still in flight. Any cart we render gets these laid over it, so a response for one line
    // can't reset another line the shopper is still changing.
    const quantityUpdateStates = new Map();
    const removingLineKeys = new Set();
    // Rows taken out by a remove that can still be undone. Undo puts the same element back, so its image is
    // already loaded rather than re-requested at a different size.
    const removedRows = new Map();
    const rowRemovalAnimations = new Map();
    const ROW_REMOVAL_ANIMATION_MS = 550;
    const ROW_RESTORATION_ANIMATION_MS = 400;
    const STACK_REPOSITION_ANIMATION_MS = 450;

    function cancelRowRemoval(lineKey) {
      const entry = rowRemovalAnimations.get(lineKey);
      if (!entry) return null;
      const computedStyle = window.getComputedStyle(entry.row);
      const startFrame = {
        opacity: computedStyle.opacity,
        transform: computedStyle.transform,
      };
      rowRemovalAnimations.delete(lineKey);
      entry.animation.cancel();
      entry.row.style.pointerEvents = '';
      entry.row.removeAttribute('aria-hidden');
      return startFrame;
    }

    function animateRowRestoration(row, startFrame) {
      if (!row) return;

      const waitStartedAt = Date.now();

      function playRestoration() {
        if (!row.isConnected) {
          if (Date.now() - waitStartedAt < ROW_REMOVAL_ANIMATION_MS * 2) {
            window.requestAnimationFrame(playRestoration);
          }
          return;
        }

        row.animate(
          [
            startFrame || { opacity: 0, transform: 'scale(0.85)' },
            { opacity: 1, transform: 'scale(1)' },
          ],
          {
            duration: ROW_RESTORATION_ANIMATION_MS,
            easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
          },
        );
      }

      playRestoration();
    }

    function animateRowRemoval(lineKey, row, onRemoved) {
      if (!row || rowRemovalAnimations.has(lineKey)) {
        if (!row && onRemoved) onRemoved();
        return;
      }

      const itemsContainer = row.parentElement;

      row.style.pointerEvents = 'none';
      row.setAttribute('aria-hidden', 'true');

      const animation = row.animate(
        [
          { opacity: 1, transform: 'scale(1)' },
          { opacity: 0, transform: 'scale(0.85)' },
        ],
        {
          duration: ROW_REMOVAL_ANIMATION_MS,
          easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
          fill: 'forwards',
        },
      );
      const entry = { animation: animation, row: row };
      rowRemovalAnimations.set(lineKey, entry);

      animation.finished
        .then(function finishRowRemoval() {
          if (rowRemovalAnimations.get(lineKey) !== entry) return;
          rowRemovalAnimations.delete(lineKey);
          const positionsBefore = captureItemRowPositions(itemsContainer, row);
          animation.cancel();
          row.remove();
          row.style.pointerEvents = '';
          row.removeAttribute('aria-hidden');

          if (rowRemovalAnimations.size === 0) {
            reconcileItems(withLocalEdits(lastKnownCart));
          }

          animateItemRowPositionChanges(positionsBefore);
          if (onRemoved) onRemoved();
        })
        .catch(function ignoreCancelledRemoval() {});
    }

    function unconfirmedQuantity(lineKey) {
      const state = quantityUpdateStates.get(lineKey);
      if (!state) return null;
      return state.pendingQuantity != null
        ? state.pendingQuantity
        : state.inFlightQuantity;
    }

    // Shifts the totals by the change in line prices, so cart-level discounts are kept until Shopify recalculates.
    function withItems(cart, items, subtotalDelta, countDelta) {
      return Object.assign({}, cart, {
        items: items,
        item_count: Math.max(0, (Number(cart.item_count) || 0) + countDelta),
        items_subtotal_price: Math.max(
          0,
          (Number(cart.items_subtotal_price) || 0) + subtotalDelta,
        ),
        total_price: Math.max(
          0,
          (Number(cart.total_price) || 0) + subtotalDelta,
        ),
      });
    }

    function withLocalEdits(cart) {
      if (!cart || !Array.isArray(cart.items)) return cart;

      let changed = false;
      let subtotalDelta = 0;
      let countDelta = 0;
      const items = [];

      cart.items.forEach(function applyLocalEdit(item) {
        const oldQuantity = Number(item.quantity) || 0;
        const oldLinePrice = Number(item.final_line_price) || 0;

        if (removingLineKeys.has(item.key)) {
          changed = true;
          subtotalDelta -= oldLinePrice;
          countDelta -= oldQuantity;
          return;
        }

        const quantity = unconfirmedQuantity(item.key);
        if (quantity == null || quantity === oldQuantity) {
          items.push(item);
          return;
        }

        const linePrice = (Number(item.final_price) || 0) * quantity;
        changed = true;
        subtotalDelta += linePrice - oldLinePrice;
        countDelta += quantity - oldQuantity;
        items.push(
          Object.assign({}, item, {
            quantity: quantity,
            final_line_price: linePrice,
            line_price: (Number(item.price) || 0) * quantity,
          }),
        );
      });

      const editedCart = changed
        ? withItems(cart, items, subtotalDelta, countDelta)
        : cart;
      return editedCart;
    }

    // Puts a restored line at the top, where Shopify puts a re-added line, so the panel, the cart page, a
    // reload and checkout all agree on the order.
    function withRestoredLine(cart, line) {
      if (!cart || !Array.isArray(cart.items) || !line || !line.key)
        return null;
      const items = cart.items.filter(function (item) {
        return item.key !== line.key;
      });
      const previous = cart.items.find(function (item) {
        return item.key === line.key;
      });
      items.unshift(line);
      return withItems(
        cart,
        items,
        (Number(line.final_line_price) || 0) -
          (previous ? Number(previous.final_line_price) || 0 : 0),
        (Number(line.quantity) || 0) -
          (previous ? Number(previous.quantity) || 0 : 0),
      );
    }

    // Updates everything except the item rows, which the shopper has already changed on screen.
    function renderLocalEdits() {
      const cart = withLocalEdits(lastKnownCart);
      if (!cart) return;
      if ((cart.item_count || 0) <= 0 && rowRemovalAnimations.size === 0)
        ensureEmptyState(true);
      updateSummary(cart);
    }

    function onCartUpdated(cart) {
      cart = withLocalEdits(cart);
      if (cart && Array.isArray(cart.items)) lastKnownCart = cart;
      if (rowRemovalAnimations.size === 0) reconcileItems(cart);
      updateSummary(cart);
    }

    // Checkout is disabled and reads "Recalculating…" while a change is still on its way to Shopify.
    function updateCheckoutPending() {
      const btn = cartPanel.querySelector('form button[name="checkout"]');
      if (!btn) return;
      const pending =
        typeof hasPendingCartWork === 'function' && hasPendingCartWork();
      if (pending === (btn.getAttribute('data-checkout-pending') === 'true'))
        return;
      if (pending) {
        btn.setAttribute('data-checkout-pending', 'true');
        btn.setAttribute('data-checkout-label', btn.textContent);
        btn.textContent =
          cartPanel.dataset.cartCheckoutPendingLabel || btn.textContent;
        btn.disabled = true;
      } else {
        btn.removeAttribute('data-checkout-pending');
        btn.textContent =
          btn.getAttribute('data-checkout-label') || checkoutLabel;
        btn.removeAttribute('data-checkout-label');
        btn.disabled = false;
        if (
          isOnCartPage() &&
          window.MegaMacCart &&
          typeof window.MegaMacCart.clearCartSummaryPendingIfIdle === 'function'
        ) {
          window.MegaMacCart.clearCartSummaryPendingIfIdle();
        }
      }
    }

    function updateSummary(cart) {
      const count = (cart && cart.item_count) || 0;
      updateTitle(count);

      updateSubtotal(
        cart && cart.items_subtotal_price ? cart.items_subtotal_price : 0,
      );
      updateTaxPill(count);
      updateFreeShipping(
        cart && cart.total_price ? cart.total_price : 0,
        count,
      );
      updateCheckoutButton(count);
      updateCartIconButtons(count);
      updateCheckoutPending();
    }

    // Shopify can mix up simultaneous changes to one cart (two undos at once came back with the wrong
    // quantity), so the panel's cart requests go one at a time. The UI doesn't wait on this; it updates first.
    // The theme-wide queue (layout/theme.liquid), shared with the cart page and the carousel, so no two cart
    // requests from any script overlap.
    const sharedQueue =
      window.MegaMacCart &&
      typeof window.MegaMacCart.queueCartRequest === 'function'
        ? window.MegaMacCart.queueCartRequest
        : (function () {
            let chain = Promise.resolve();
            return function (send) {
              const r = chain.then(send, send);
              chain = r.catch(function () {});
              return r;
            };
          })();
    let cartRequestChain = Promise.resolve();

    let cartRequestsActive = 0;

    function queueCartRequest(send) {
      cartRequestsActive += 1;
      const result = sharedQueue(send);
      cartRequestChain = result.catch(function () {});
      function settled() {
        cartRequestsActive -= 1;
        // After the code awaiting this request has cleared its own state (its finally blocks run first).
        window.setTimeout(updateCheckoutPending, 0);
      }
      result.then(settled, settled);
      return result;
    }

    // On the cart page, Shopify renders the cart section into the same response (`sections`), which saves the
    // page a second request to catch up with the panel.
    const cartPageHtmlByResponse = new WeakMap();

    function cartPageSectionId() {
      if (!isOnCartPage()) return '';
      if (
        !window.MegaMacCart ||
        typeof window.MegaMacCart.getNewCartSectionId !== 'function'
      )
        return '';
      return window.MegaMacCart.getNewCartSectionId() || '';
    }

    function withCartPageSection(body) {
      const sectionId = cartPageSectionId();
      if (!sectionId) return body;
      return Object.assign({}, body, {
        sections: sectionId,
        sections_url: window.location.pathname,
      });
    }

    function takeCartPageSection(response, sectionId) {
      // Counted even without section HTML, so the page knows its own prefetched HTML may now be stale.
      const seq =
        window.MegaMacCart &&
        typeof window.MegaMacCart.noteCartMutation === 'function'
          ? window.MegaMacCart.noteCartMutation()
          : 0;
      if (!response || !response.sections) return response;
      const html = sectionId ? response.sections[sectionId] : '';
      delete response.sections;
      if (html) cartPageHtmlByResponse.set(response, { html: html, seq: seq });
      return response;
    }

    function postCart(url, body) {
      return queueCartRequest(async function sendCartRequest() {
        const sectionId = cartPageSectionId();
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(withCartPageSection(body)),
        });

        if (!res.ok) {
          // Shopify says why with a 422 (e.g. not enough stock); the status lets the caller tell that from a
          // network failure.
          const err = new Error('Cart request failed');
          err.status = res.status;
          throw err;
        }
        return takeCartPageSection(await res.json(), sectionId);
      });
    }

    function changeCartLineQuantity(lineKey, quantity) {
      return postCart('/cart/change.js', { id: lineKey, quantity: quantity });
    }

    // `response`: the cart request just made, to render the page from the section HTML it carried.
    function syncCartPageIfPresent(response) {
      if (!isOnCartPage()) return;

      // Delegate cart page DOM refresh to the shared implementation defined in `sections/new-cart.liquid`.
      // Not awaited: the panel is already up to date, and the latest refresh wins if several overlap.
      if (
        window.MegaMacCart &&
        typeof window.MegaMacCart.refreshNewCartSection === 'function'
      ) {
        // Only redraw from the reply's HTML if nothing else has changed the cart since; otherwise fetch it fresh.
        const saved = response ? cartPageHtmlByResponse.get(response) : null;
        const current =
          saved &&
          (typeof window.MegaMacCart.cartMutationSeq !== 'function' ||
            window.MegaMacCart.cartMutationSeq() === saved.seq);
        window.MegaMacCart.refreshNewCartSection(
          current ? saved.html : undefined,
        );
      }
    }

    // On the cart page, show the change on the page at the same moment as in the panel (hooks in
    // `sections/new-cart.liquid`); the section HTML from Shopify's reply then confirms it.
    function previewCartPage(hook) {
      if (
        !isOnCartPage() ||
        !window.MegaMacCart ||
        typeof window.MegaMacCart[hook] !== 'function'
      )
        return;
      try {
        window.MegaMacCart[hook].apply(
          null,
          Array.prototype.slice.call(arguments, 1),
        );
      } catch (_) {}
    }

    // Queued behind any pending change, so it reads the cart after them rather than a half-updated one.
    function refetchCart() {
      return queueCartRequest(function readCart() {
        if (
          window.MegaMacCart &&
          typeof window.MegaMacCart.fetchCartAndEmit === 'function'
        ) {
          return window.MegaMacCart.fetchCartAndEmit();
        }
        return null;
      });
    }

    function scheduleQuantityUpdate(input, quantity, immediate) {
      const lineKey = input.getAttribute('data-cart-line-key');
      if (!lineKey) return;

      let state = quantityUpdateStates.get(lineKey);
      if (!state) {
        state = {
          timer: null,
          inFlightQuantity: null,
          inFlightPromise: null,
          pendingQuantity: null,
        };
        quantityUpdateStates.set(lineKey, state);
      }

      state.pendingQuantity = quantity;
      renderLocalEdits();
      previewCartPage('previewLineQuantity', lineKey, quantity);

      // Short debounce so a burst of +/- clicks goes to Shopify as one request.
      if (state.timer) window.clearTimeout(state.timer);
      state.timer = window.setTimeout(
        function () {
          state.timer = null;
          drainQuantityUpdates(lineKey, state);
        },
        immediate ? 0 : 200,
      );
    }

    async function drainQuantityUpdates(lineKey, state) {
      if (state.inFlightPromise || state.pendingQuantity == null) return;

      const quantity = state.pendingQuantity;
      state.pendingQuantity = null;
      state.inFlightQuantity = quantity;

      try {
        state.inFlightPromise = changeCartLineQuantity(lineKey, quantity);
        const cart = await state.inFlightPromise;
        state.inFlightQuantity = null;
        onCartUpdated(cart);
        if (state.pendingQuantity == null) {
          if (
            window.MegaMacCart &&
            typeof window.MegaMacCart.emitCartQuantityChanged === 'function'
          ) {
            window.MegaMacCart.emitCartQuantityChanged(cart);
          }
          // A remove for this line is already on its way; its own reply redraws the page without the line.
          if (!removingLineKeys.has(lineKey)) syncCartPageIfPresent(cart);
        }
      } catch (err) {
        state.inFlightQuantity = null;
        // Put the line back to what Shopify has (e.g. not enough stock), unless the shopper has already moved on.
        if (state.pendingQuantity == null) {
          refetchCart().then(function (cart) {
            // Only a refusal from Shopify (422) means the line is at its stock; a network failure says nothing
            // about stock, so it must not become a cap.
            if (err && err.status === 422)
              showStockNoticeIfShort(lineKey, quantity, cart);
          });
          // The cart page was already shown the new quantity; put it back to what Shopify has.
          syncCartPageIfPresent();
        }
      } finally {
        state.inFlightPromise = null;
        if (state.pendingQuantity != null) drainQuantityUpdates(lineKey, state);
        else {
          if (!state.timer) quantityUpdateStates.delete(lineKey);
          previewCartPage('clearPanelPending', lineKey);
        }
        updateCheckoutPending();
      }
    }

    // The same ceiling as the cart page's quantity boxes, so the two never disagree above it.
    const MAX_LINE_QUANTITY = 999;

    // A row's cap: its `max` (rendered with the page, or learned since), else the ceiling.
    function lineMaxQty(input) {
      const attr = parseInt(input.getAttribute('max') || '', 10);
      if (Number.isFinite(attr))
        return Math.min(MAX_LINE_QUANTITY, Math.max(1, attr));
      return MAX_LINE_QUANTITY;
    }

    function variantIdForInput(input) {
      const row = input.closest('.header__icons__panel__cart__content__item');
      const btn = row && row.querySelector('[data-cart-remove-ajax]');
      return btn ? btn.getAttribute('data-cart-variant-id') || '' : '';
    }

    // + stops at the cap, as on the cart page; hovering it then says why ("Only N available").
    function syncIncrementButton(input) {
      const scope =
        input.closest('.header__icons__panel__cart__content__item__actions') ||
        input.closest('.header__icons__panel__cart__content__item');
      const inc =
        scope && scope.querySelector('[data-mini-cart-quantity-increment]');
      if (!inc) return;
      const max = lineMaxQty(input);
      // Off at the cap, but still clickable: a click then shows the "Only N available" notice instead of counting.
      const atCap = (parseInt(input.value, 10) || 1) >= max;
      inc.setAttribute('aria-disabled', atCap ? 'true' : 'false');
      const region = cartPanel.querySelector('[data-mini-cart-undo-region]');
      const template =
        (region &&
          region.getAttribute('data-mini-cart-stock-template-generic')) ||
        '';
      inc.title =
        atCap && input.getAttribute('data-cart-stock-limited') === 'true'
          ? template.replace('__QTY__', String(max))
          : '';
    }

    // Remember a stock cap for this row and for the variant (so a later row for it starts capped too).
    function setLineMaxQty(input, max) {
      input.setAttribute('max', String(max));
      input.setAttribute('data-cart-stock-limited', 'true');
      const variantId = variantIdForInput(input);
      if (variantId && cartMaxQtyStore) cartMaxQtyStore.set(variantId, max);
      syncIncrementButton(input);
    }

    function setMiniCartQuantity(input, quantity, immediate) {
      const lineKey = input.getAttribute('data-cart-line-key');
      const max = lineMaxQty(input);
      const unconfirmed = lineKey ? unconfirmedQuantity(lineKey) : null;
      const current =
        unconfirmed != null
          ? unconfirmed
          : parseInt(
              input.getAttribute('data-cart-quantity-baseline') || '',
              10,
            );
      const parsed = parseInt(quantity, 10);
      // Nothing readable (an emptied box, or a stray e, + or -) means no new quantity: the last one stays.
      const wanted = Number.isNaN(parsed)
        ? Number.isFinite(current)
          ? current
          : 1
        : Math.max(1, parsed);
      const nextQuantity = Math.min(max, wanted);
      input.value = String(nextQuantity);
      syncIncrementButton(input);
      // Typed past the stock: held at the cap, and told why (the cart page says the same).
      if (
        wanted > max &&
        input.getAttribute('data-cart-stock-limited') === 'true'
      )
        showStockNotice(lineKey, max);
      // Nothing to send when the value hasn't changed (e.g. − pressed at 1, or the same number typed again).
      if (Number.isFinite(current) && current === nextQuantity) return;
      scheduleQuantityUpdate(input, nextQuantity, immediate);
    }

    // Digits only in the panel's quantity boxes: a number box still lets e, +, - and . through.
    cartPanel.addEventListener('keydown', function onQuantityKeydown(event) {
      const input = event.target.closest('[data-mini-cart-quantity-input]');
      if (!input || !cartPanel.contains(input)) return;
      if (
        event.key.length === 1 &&
        !/[0-9]/.test(event.key) &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.altKey
      ) {
        event.preventDefault();
      }
    });

    cartPanel.addEventListener('click', function onQuantityButtonClick(event) {
      const button = event.target.closest(
        '[data-mini-cart-quantity-decrement], [data-mini-cart-quantity-increment]',
      );
      if (!button || !cartPanel.contains(button)) return;

      const actions = button.closest(
        '.header__icons__panel__cart__content__item__actions',
      );
      const input =
        actions && actions.querySelector('[data-mini-cart-quantity-input]');
      if (!input) return;

      event.preventDefault();
      const current = parseInt(input.value, 10) || 1;
      const delta = button.hasAttribute('data-mini-cart-quantity-increment')
        ? 1
        : -1;
      setMiniCartQuantity(input, current + delta, false);
    });

    cartPanel.addEventListener('change', function onQuantityInputChange(event) {
      const input = event.target.closest('[data-mini-cart-quantity-input]');
      if (!input || !cartPanel.contains(input)) return;
      setMiniCartQuantity(input, input.value, true);
    });

    /* ── undo after remove ── */
    const UNDO_DURATION = 15000;
    const undoRegion = cartPanel.querySelector('[data-mini-cart-undo-region]');
    const undoTemplate = cartPanel.querySelector(
      'template[data-mini-cart-undo-template]',
    );
    const undoEntries = new Set();
    // Re-adds still on their way to Shopify, by line key, so a new remove of that line waits for them.
    const undoInFlight = new Map();
    const noticeAnimations = new WeakMap();

    function animateNoticeRegionMutation(mutation) {
      if (!undoRegion) return;
      const itemsContainer = undoRegion.parentElement;
      const itemPositions = captureItemRowPositions(itemsContainer);
      const noticePositions = captureNoticePositions();
      mutation();
      animateNoticePositionChanges(noticePositions);
      animateItemRowPositionChanges(itemPositions);
    }

    function insertCartNotice(toast, replacedToast) {
      if (replacedToast) {
        const replacedAnimation = noticeAnimations.get(replacedToast);
        if (replacedAnimation) replacedAnimation.cancel();
        noticeAnimations.delete(replacedToast);
      }
      animateNoticeRegionMutation(function insertNotice() {
        if (replacedToast) replacedToast.remove();
        undoRegion.insertBefore(toast, undoRegion.firstChild);
      });
    }

    function captureNoticePositions(excludedToast) {
      const positions = new Map();
      if (!undoRegion) return positions;
      Array.from(undoRegion.children).forEach(function captureNotice(toast) {
        if (toast === excludedToast) return;
        positions.set(toast, toast.getBoundingClientRect().top);
      });
      return positions;
    }

    function animateNoticePositionChanges(positions) {
      positions.forEach(function animateNoticePosition(previousTop, toast) {
        if (!toast.isConnected) return;
        animateStackPositionChange(toast, previousTop);
      });
    }

    function animateCartNoticeIn(toast) {
      const animation = toast.animate(
        [
          { opacity: 0, transform: 'scale(0.85)' },
          { opacity: 1, transform: 'scale(1)' },
        ],
        {
          duration: ROW_RESTORATION_ANIMATION_MS,
          easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
        },
      );
      noticeAnimations.set(toast, animation);
      function clearNoticeEntrance() {
        if (noticeAnimations.get(toast) === animation) {
          noticeAnimations.delete(toast);
        }
      }
      animation.finished.then(clearNoticeEntrance, clearNoticeEntrance);
    }

    function dismissCartNotice(toast) {
      if (!toast || !toast.isConnected || toast.dataset.dismissing === 'true')
        return;
      toast.dataset.dismissing = 'true';
      // A leaving notice takes no more clicks: its Undo has been used or has lapsed.
      toast.style.pointerEvents = 'none';

      const entrance = noticeAnimations.get(toast);
      const computedStyle = window.getComputedStyle(toast);
      const startFrame = {
        opacity: computedStyle.opacity,
        transform: computedStyle.transform,
      };
      if (entrance) entrance.cancel();

      const animation = toast.animate(
        [startFrame, { opacity: 0, transform: 'scale(0.85)' }],
        {
          duration: ROW_REMOVAL_ANIMATION_MS,
          easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
          fill: 'forwards',
        },
      );
      noticeAnimations.set(toast, animation);

      animation.finished
        .then(function removeNotice() {
          if (noticeAnimations.get(toast) !== animation) return;
          noticeAnimations.delete(toast);
          animation.cancel();
          animateNoticeRegionMutation(function removeNoticeFromRegion() {
            toast.remove();
          });
        })
        .catch(function ignoreCancelledNoticeDismissal() {});
    }

    function dismissUndo(entry) {
      if (!undoEntries.has(entry)) return;
      undoEntries.delete(entry);
      window.clearTimeout(entry.timer);
      if (entry.toast) dismissCartNotice(entry.toast);
      if (
        removedRows.get(entry.lineKey) &&
        !removedRows.get(entry.lineKey).isConnected
      ) {
        removedRows.delete(entry.lineKey);
      }
    }

    function dismissUndoForVariant(variantId) {
      if (!variantId) return;
      undoEntries.forEach(function (entry) {
        if (entry.variantId === String(variantId)) dismissUndo(entry);
      });
    }

    function scrollPanelToUndoNotice() {
      if (!undoRegion || !undoRegion.parentElement) return;
      const list = undoRegion.parentElement;
      window.requestAnimationFrame(function () {
        list.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }

    function showUndo(entry) {
      if (
        !undoRegion ||
        !undoTemplate ||
        !undoTemplate.content.firstElementChild ||
        !entry.variantId
      )
        return;

      const toast = undoTemplate.content.firstElementChild.cloneNode(true);
      const textEl = toast.querySelector('[data-mini-cart-undo-text]');
      if (textEl) textEl.textContent = decodeEntities(entry.message || '');

      const undoBtn = toast.querySelector('[data-mini-cart-undo-btn]');
      if (undoBtn) {
        undoBtn.addEventListener('click', function () {
          // A copy of the cart page's own message: the page does the undo, as it knows its remove's state.
          if (entry.owner === 'page') {
            dismissUndo(entry);
            if (
              window.MegaMacCart &&
              typeof window.MegaMacCart.undoPageRemoval === 'function'
            ) {
              window.MegaMacCart.undoPageRemoval(entry.variantId);
            }
            return;
          }
          undoRemove(entry);
        });
      }

      const closeBtn = toast.querySelector('[data-mini-cart-undo-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dismissUndo(entry);
          // Close the matching message on the cart page too.
          if (
            window.MegaMacCart &&
            typeof window.MegaMacCart.dismissUndoForVariant === 'function'
          ) {
            window.MegaMacCart.dismissUndoForVariant(entry.variantId);
          }
        });
      }

      entry.toast = toast;
      entry.timer = window.setTimeout(function () {
        dismissUndo(entry);
      }, UNDO_DURATION);
      undoEntries.add(entry);
      insertCartNotice(toast);
      animateCartNoticeIn(toast);
      scrollPanelToUndoNotice();
    }

    // Shopify refused a quantity (not enough stock) and the line was put back to what it holds: say so, as the
    // cart page does, rather than have the number silently snap back. Same message layout as the undo notice.
    const STOCK_NOTICE_DURATION = 5000;
    let stockNoticeTimer = null;

    function showStockNoticeIfShort(lineKey, requested, cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      const line = cart.items.find(function (item) {
        return item.key === lineKey;
      });
      if (!line || !(line.quantity < requested)) return;
      // Shopify held the line at its stock: that is the cap from now on, and + stops there.
      const input = cartPanel.querySelector(
        '[data-mini-cart-quantity-input][data-cart-line-key="' +
          CSS.escape(lineKey) +
          '"]',
      );
      if (input) setLineMaxQty(input, line.quantity);
      showStockNotice(lineKey, line.quantity);
      previewCartPage('showCartStockNotice', lineKey, line.quantity);
    }

    // Brings the row for this variant into view in the panel's list. Shopify keeps an existing line where it
    // was, so an item added again can sit well down a long cart; the panel would otherwise open at the top.
    function scrollPanelToVariant(variantId) {
      const btn =
        variantId &&
        cartPanel.querySelector(
          '[data-cart-remove-ajax][data-cart-variant-id="' +
            CSS.escape(String(variantId)) +
            '"]',
        );
      const row =
        btn && btn.closest('.header__icons__panel__cart__content__item');
      const list =
        row && row.closest('.header__icons__panel__cart__content__items');
      if (!list) return;
      // Measured once the panel is laid out. Nothing to do for a short cart (the list doesn't scroll) or a
      // line already in view.
      window.requestAnimationFrame(function () {
        if (list.scrollHeight <= list.clientHeight) return;
        const offset =
          row.getBoundingClientRect().top - list.getBoundingClientRect().top;
        if (offset >= 0 && offset + row.offsetHeight <= list.clientHeight)
          return;
        list.scrollTo({ top: list.scrollTop + offset, behavior: 'smooth' });
      });
    }

    function openCartPanelAt(variantId) {
      if (
        window.MegaMacUI &&
        typeof window.MegaMacUI.openCartPanel === 'function'
      )
        window.MegaMacUI.openCartPanel();
      scrollPanelToVariant(variantId);
    }

    // The product page: the shopper pressed Add to Cart with the whole stock already in the bag. Open the
    // panel on that line and say why nothing was added.
    window.MegaMacCart.showPanelStockLimit = function showPanelStockLimit(
      variantId,
      maxQty,
    ) {
      const line =
        lastKnownCart && Array.isArray(lastKnownCart.items)
          ? lastKnownCart.items.find(function (item) {
              return String(item.variant_id) === String(variantId);
            })
          : null;
      if (line) showStockNotice(line.key, maxQty);
      openCartPanelAt(variantId);
    };

    // "Only N {title} available", the cart page's wording, for the line with this key.
    function showStockNotice(lineKey, maxQty) {
      if (
        !undoRegion ||
        !undoTemplate ||
        !undoTemplate.content.firstElementChild
      )
        return;
      const line =
        lastKnownCart && Array.isArray(lastKnownCart.items)
          ? lastKnownCart.items.find(function (item) {
              return item.key === lineKey;
            })
          : null;
      const withTitle =
        undoRegion.getAttribute('data-mini-cart-stock-template') || '';
      const generic =
        undoRegion.getAttribute('data-mini-cart-stock-template-generic') || '';
      const title = (line && line.product_title) || '';
      const template = title && withTitle ? withTitle : generic;
      const text = template
        .replace('__QTY__', String(maxQty))
        .replace('__TITLE__', title);
      if (!text) return;

      const existing = undoRegion.querySelector(
        '[data-mini-cart-stock-notice]',
      );
      if (stockNoticeTimer) window.clearTimeout(stockNoticeTimer);

      const toast = undoTemplate.content.firstElementChild.cloneNode(true);
      toast.removeAttribute('data-mini-cart-undo');
      toast.setAttribute('data-mini-cart-stock-notice', '');
      const undoBtn = toast.querySelector('[data-mini-cart-undo-btn]');
      if (undoBtn) undoBtn.remove();
      const textEl = toast.querySelector('[data-mini-cart-undo-text]');
      if (textEl) textEl.textContent = decodeEntities(text);
      const closeBtn = toast.querySelector('[data-mini-cart-undo-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dismissCartNotice(toast);
        });
      }
      insertCartNotice(toast, existing);
      animateCartNoticeIn(toast);
      stockNoticeTimer = window.setTimeout(function () {
        dismissCartNotice(toast);
      }, STOCK_NOTICE_DURATION);
    }

    // On the cart page, a remove shows an undo message both here and on the page. These let the page show a
    // copy of its own removes here, and pass Undo / close on a copy of ours back to this panel.
    window.MegaMacCart.showPanelUndo = function showPanelUndo(payload) {
      if (!payload || !payload.variantId) return;
      dismissUndoForVariant(payload.variantId);
      showUndo({
        owner: 'page',
        variantId: String(payload.variantId),
        message: payload.message || '',
      });
    };

    window.MegaMacCart.dismissPanelUndo = dismissUndoForVariant;

    // The cart page's own remove and undo, mirrored here at once (the page's reply then confirms them).
    const pageRemovedLines = new Map();

    window.MegaMacCart.panelPreviewRemove = function panelPreviewRemove(
      lineKey,
    ) {
      if (!lineKey || removingLineKeys.has(lineKey)) return;
      const shownCart = withLocalEdits(lastKnownCart);
      const line =
        shownCart && Array.isArray(shownCart.items)
          ? shownCart.items.find(function (item) {
              return item.key === lineKey;
            })
          : null;
      if (line) {
        const previous = pageRemovedLines.get(lineKey);
        if (previous) window.clearTimeout(previous.timer);
        // Kept for as long as the page offers its undo, so a late undo can show the row again at once.
        const timer = window.setTimeout(function () {
          if (
            pageRemovedLines.get(lineKey) &&
            pageRemovedLines.get(lineKey).timer === timer
          ) {
            pageRemovedLines.delete(lineKey);
            const row = removedRows.get(lineKey);
            if (row && !row.isConnected) removedRows.delete(lineKey);
          }
        }, UNDO_DURATION + 1000);
        pageRemovedLines.set(lineKey, {
          line: line,
          timer: timer,
        });
      }
      removingLineKeys.add(lineKey);
      const input = cartPanel.querySelector(
        '[data-mini-cart-quantity-input][data-cart-line-key="' +
          CSS.escape(lineKey) +
          '"]',
      );
      const row =
        input && input.closest('.header__icons__panel__cart__content__item');
      if (row) {
        removedRows.set(lineKey, row);
        animateRowRemoval(lineKey, row);
      }
      renderLocalEdits();
    };

    window.MegaMacCart.panelConfirmRemove = function panelConfirmRemove(
      lineKey,
      restoreAuthoritativeCart,
    ) {
      removingLineKeys.delete(lineKey);
      // The line counted as pending work (Checkout read "Recalculating"); it no longer does.
      updateCheckoutPending();
      if (restoreAuthoritativeCart) refetchCart();
    };

    window.MegaMacCart.panelPreviewRestore = function panelPreviewRestore(
      variantId,
    ) {
      let lineKey = '';
      pageRemovedLines.forEach(function (saved, key) {
        if (String(saved.line.variant_id) === String(variantId)) lineKey = key;
      });
      if (!lineKey) return;
      const saved = pageRemovedLines.get(lineKey);
      window.clearTimeout(saved.timer);
      pageRemovedLines.delete(lineKey);
      removingLineKeys.delete(lineKey);
      const restorationStart = cancelRowRemoval(lineKey);
      const row = removedRows.get(lineKey);
      const restored = withRestoredLine(lastKnownCart, saved.line);
      if (restored) onCartUpdated(restored);
      animateRowRestoration(row, restorationStart);
      removedRows.delete(lineKey);
      updateCheckoutPending();
    };

    // Returns false when this panel has no undo for it (e.g. after a reload), so the page does it itself.
    window.MegaMacCart.undoPanelRemoval = function undoPanelRemoval(variantId) {
      let found = null;
      undoEntries.forEach(function (entry) {
        if (
          !found &&
          entry.owner !== 'page' &&
          !entry.undone &&
          entry.variantId === String(variantId)
        )
          found = entry;
      });
      if (!found) return false;
      undoRemove(found);
      return true;
    };

    async function undoRemove(entry) {
      if (entry.undone) return;
      entry.undone = true;
      removingLineKeys.delete(entry.lineKey);
      const restorationStart = cancelRowRemoval(entry.lineKey);
      const row = removedRows.get(entry.lineKey);
      previewCartPage('previewLineRestored', entry.lineKey);

      // Show the line again straight away, reusing its original row; Shopify's reply below corrects the details.
      const restored = withRestoredLine(lastKnownCart, entry.line);
      if (restored) onCartUpdated(restored);
      animateRowRestoration(row, restorationStart);
      removedRows.delete(entry.lineKey);
      dismissUndo(entry);

      // Also clear the cart page's own undo notice for this item, if there is one.
      if (
        window.MegaMacCart &&
        typeof window.MegaMacCart.dismissUndoForVariant === 'function'
      ) {
        window.MegaMacCart.dismissUndoForVariant(entry.variantId);
      }

      const readd = (async function readdLine() {
        try {
          // The remove may still be in flight; re-add only once it has landed.
          try {
            await entry.removal;
          } catch (_) {}

          const addedItem = await postCart('/cart/add.js', {
            id: entry.variantId,
            quantity: entry.quantity,
          });

          const cart = await refetchCart();
          if (
            window.MegaMacCart &&
            typeof window.MegaMacCart.emitCartAdded === 'function'
          ) {
            window.MegaMacCart.emitCartAdded(
              cart,
              addedItem,
              entry.quantity,
              'undo',
            );
          }
          syncCartPageIfPresent(addedItem);
        } catch (_) {
          refetchCart();
          syncCartPageIfPresent();
        }
      })();
      undoInFlight.set(entry.lineKey, readd);
      await readd;
      if (undoInFlight.get(entry.lineKey) === readd)
        undoInFlight.delete(entry.lineKey);
      updateCheckoutPending();
    }

    document.addEventListener('click', function onRemoveClick(event) {
      const btn = event.target.closest('[data-cart-remove-ajax]');
      if (!btn) return;
      if (!cartPanel.contains(btn)) return;

      event.preventDefault();

      const lineKey = btn.getAttribute('data-cart-line-key');
      if (!lineKey || removingLineKeys.has(lineKey)) return;

      // Capture the line as the shopper sees it (including an unsent quantity change) so undo can restore it.
      const shownCart = withLocalEdits(lastKnownCart);
      const line =
        shownCart && Array.isArray(shownCart.items)
          ? shownCart.items.find(function (item) {
              return item.key === lineKey;
            })
          : null;
      const variantId =
        btn.getAttribute('data-cart-variant-id') ||
        (line ? String(line.variant_id) : '');
      const quantity = line
        ? line.quantity
        : parseInt(btn.getAttribute('data-cart-quantity') || '1', 10) || 1;
      // Decoded once: the translation already escapes the title, and the attribute escapes it again.
      const message = decodeEntities(
        btn.getAttribute('data-cart-undo-message') || '',
      );

      // Drop any queued quantity change for this line; the remove supersedes it.
      const quantityState = quantityUpdateStates.get(lineKey);
      const inFlightQuantityChange = quantityState
        ? quantityState.inFlightPromise
        : null;
      if (quantityState) {
        if (quantityState.timer) window.clearTimeout(quantityState.timer);
        quantityState.timer = null;
        quantityState.pendingQuantity = null;
      }

      // Take the row out and update the totals now, then tell Shopify.
      removingLineKeys.add(lineKey);
      const entry = {
        lineKey: lineKey,
        variantId: variantId,
        quantity: quantity,
        message: message,
        line: line,
        undone: false,
        removeFailed: false,
        exitComplete: false,
        reconciling: false,
      };
      let undoShown = false;
      function showRemovalUndo() {
        entry.exitComplete = true;
        if (undoShown || entry.removeFailed || entry.reconciling) return;
        undoShown = true;
        // Show the undo on the cart page too; its Undo comes back here (owner 'panel').
        previewCartPage('enqueueUndo', {
          variantId: variantId,
          quantity: quantity,
          message: message,
          unitCents: line ? line.final_price : undefined,
          owner: 'panel',
        });
        showUndo(entry);
      }
      const row = btn.closest('.header__icons__panel__cart__content__item');
      if (row) {
        removedRows.set(lineKey, row);
        animateRowRemoval(lineKey, row, showRemovalUndo);
      } else showRemovalUndo();
      renderLocalEdits();
      previewCartPage('previewLineRemoved', lineKey);

      const priorUndo = undoInFlight.get(lineKey);
      // Likewise a re-add from the cart page's own undo message.
      const priorPageReadd =
        window.MegaMacCart &&
        typeof window.MegaMacCart.pageReaddInFlight === 'function'
          ? window.MegaMacCart.pageReaddInFlight(variantId)
          : null;
      entry.removal = (async function removeLine() {
        // An undo of this same line may still be re-adding it; removing before that lands would fail.
        if (priorUndo) await priorUndo;
        if (priorPageReadd) {
          try {
            await priorPageReadd;
          } catch (_) {}
        }
        if (inFlightQuantityChange) {
          try {
            await inFlightQuantityChange;
          } catch (_) {}
        }
        const cart = await changeCartLineQuantity(lineKey, 0);
        removingLineKeys.delete(lineKey);
        // Undo was pressed while this was in flight; it renders the cart itself once the line is re-added.
        if (entry.undone) return;

        onCartUpdated(cart);
        if (
          window.MegaMacCart &&
          typeof window.MegaMacCart.emitCartRemoved === 'function'
        ) {
          window.MegaMacCart.emitCartRemoved(cart, variantId, quantity);
        }
        syncCartPageIfPresent(cart);
      })();

      entry.removal.catch(async function () {
        removingLineKeys.delete(lineKey);
        entry.reconciling = true;
        // Show what Shopify has: the line is either already gone (a page-side remove got there first, and the
        // undo still works) or still there (the remove failed, so the row comes back and the undo goes).
        if (entry.undone) {
          refetchCart();
          return;
        }
        const cart = await refetchCart();
        const stillThere =
          cart &&
          Array.isArray(cart.items) &&
          cart.items.some(function (item) {
            return item.key === lineKey;
          });
        if (stillThere || !cart) {
          entry.removeFailed = true;
          dismissUndo(entry);
          previewCartPage('dismissUndoForVariant', variantId);
        } else {
          entry.reconciling = false;
          if (entry.exitComplete) showRemovalUndo();
        }
        syncCartPageIfPresent();
      });
    });

    // A cart page redraw from one reply shows the cart as Shopify had it then: lines this panel is still
    // removing or changing would come back or show an old quantity. Lay the pending edits over it again.
    document.addEventListener(
      'megamac:cart:domrefreshed',
      function reapplyLocalEditsToPage() {
        if (!isOnCartPage()) return;
        removingLineKeys.forEach(function (lineKey) {
          previewCartPage('previewLineRemoved', lineKey);
        });
        quantityUpdateStates.forEach(function (state, lineKey) {
          const quantity = unconfirmedQuantity(lineKey);
          if (quantity != null)
            previewCartPage('previewLineQuantity', lineKey, quantity);
        });
      },
    );

    /* ── checkout waits for changes still on their way ── */
    function hasPendingCartWork() {
      let pending =
        removingLineKeys.size > 0 ||
        undoInFlight.size > 0 ||
        cartRequestsActive > 0 ||
        (window.MegaMacCart.cartRequestsInFlight || 0) > 0;
      quantityUpdateStates.forEach(function (state) {
        if (state.pendingQuantity != null || state.inFlightPromise)
          pending = true;
      });
      return pending;
    }

    // Sends any debounced quantity change now, then resolves once nothing is left in flight.
    async function waitForCartIdle() {
      quantityUpdateStates.forEach(function (state, lineKey) {
        if (state.timer) {
          window.clearTimeout(state.timer);
          state.timer = null;
          drainQuantityUpdates(lineKey, state);
        }
      });
      for (let i = 0; i < 100 && hasPendingCartWork(); i += 1) {
        await cartRequestChain;
        await new Promise(function (resolve) {
          window.setTimeout(resolve, 50);
        });
      }
    }

    window.MegaMacCart.hasPendingPanelCartWork = hasPendingCartWork;
    // Bumped whenever any cart request starts or settles (the theme-wide queue calls this for every script's
    // requests), so a plain read can tell whether a change overtook it.
    let cartActivitySeq = 0;
    window.MegaMacCart.onCartRequestSettled = function onCartRequestSettled() {
      cartActivitySeq += 1;
      updateCheckoutPending();
    };
    window.MegaMacCart.waitForPanelCartIdle = waitForCartIdle;

    // Checkout posts the cart as Shopify holds it, so a change made a moment ago must land first. The button
    // reads "Recalculating" for the half second that takes.
    cartPanel.addEventListener('submit', function waitBeforeCheckout(event) {
      const form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.dataset.checkoutReady === 'true') {
        delete form.dataset.checkoutReady;
        return;
      }
      if (!hasPendingCartWork()) return;
      event.preventDefault();

      const btn = form.querySelector('button[name="checkout"]');
      updateCheckoutPending();
      waitForCartIdle().then(function () {
        updateCheckoutPending();
        form.dataset.checkoutReady = 'true';
        if (btn && typeof form.requestSubmit === 'function') {
          form.requestSubmit(btn);
        } else {
          // Older browsers: form.submit() leaves out the button's name, which Shopify needs to go to checkout.
          const checkoutField = document.createElement('input');
          checkoutField.type = 'hidden';
          checkoutField.name = 'checkout';
          checkoutField.value = '1';
          form.appendChild(checkoutField);
          form.submit();
        }
      });
    });

    // The item was added back some other way (the cart page's own undo, an upsell, add to cart): its undo is stale.
    document.addEventListener(
      'megamac:cart:added',
      function onCartAddedDismissUndo(e) {
        // An undo's own re-add already cleared its message; it must not clear the message of a newer remove of
        // the same item made while that re-add was still on its way.
        if (e && e.detail && e.detail.source === 'undo') return;
        const addedItem = e && e.detail && e.detail.addedItem;
        const lines =
          addedItem && Array.isArray(addedItem.items)
            ? addedItem.items
            : [addedItem];
        lines.forEach(function (line) {
          if (line && line.variant_id) dismissUndoForVariant(line.variant_id);
        });
      },
    );

    // When the panel last drew from a cart Shopify sent (not one it built itself).
    let lastCartReadAt = 0;
    const CART_READ_FRESH_MS = 3000;

    document.addEventListener('megamac:cart:updated', function (e) {
      if (!e || !e.detail || !e.detail.cart) return;
      lastCartReadAt = Date.now();
      onCartUpdated(e.detail.cart);
    });

    // A plain read of the cart, outside the request queue: it is not a change, so Checkout must not show
    // "Recalculating" for it. Skipped while a change is on its way, since that change's own reply redraws the panel.
    async function readCartQuietly() {
      if (hasPendingCartWork()) return null;
      const activityAtStart = cartActivitySeq;
      let cart = null;
      try {
        const res = await fetch('/cart.js', {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (res.ok) cart = await res.json();
      } catch (_) {}
      // A change started or landed while this read was on its way: its reply is the newer picture, so this one
      // is dropped rather than drawn over it.
      if (!cart || cartActivitySeq !== activityAtStart || hasPendingCartWork())
        return null;
      window.MegaMacCart.emitCartUpdated(cart);
      return cart;
    }

    // Opening the panel re-reads the cart unless it was read moments ago (e.g. by the add that opened it).
    document.addEventListener('megamac:panel:opened', function (e) {
      if (!e || !e.detail || e.detail.panel !== 'cart') return;
      if (Date.now() - lastCartReadAt < CART_READ_FRESH_MS) return;
      readCartQuietly();
    });

    function isOnCartPage() {
      const path = (window.location.pathname || '').replace(/\/+$/, '');
      const isCartPage = path === '/cart' || path.endsWith('/cart');
      return isCartPage;
    }

    // Rows rendered with the page: + stops at the cap from the start.
    cartPanel
      .querySelectorAll('[data-mini-cart-quantity-input]')
      .forEach(syncIncrementButton);

    // A line holding more than its stock (the stock fell after it was added, or an add slipped past): bring it
    // down to the cap Shopify will enforce at checkout anyway, and say so. Keeps the count honest everywhere.
    cartPanel
      .querySelectorAll(
        '[data-mini-cart-quantity-input][data-cart-stock-limited="true"]',
      )
      .forEach(function (input) {
        const max = lineMaxQty(input);
        const qty = parseInt(input.value, 10) || 1;
        if (qty <= max) return;
        const lineKey = input.getAttribute('data-cart-line-key');
        setMiniCartQuantity(input, max, true);
        showStockNotice(lineKey, max);
        // The cart page shows the same message next to its own row, once its own script has set up (it runs
        // after this one).
        const notifyPage = function () {
          window.setTimeout(function () {
            previewCartPage('showCartStockNotice', lineKey, max);
          }, 0);
        };
        if (document.readyState === 'loading')
          document.addEventListener('DOMContentLoaded', notifyPage);
        else notifyPage();
      });

    document.addEventListener(
      'megamac:cart:added',
      async function onAddFeedback(e) {
        const detail = (e && e.detail) || {};
        if (detail.source === 'undo') return;

        const addedItem = detail.addedItem;
        const addedImageUrl = detail.imageUrl || '';
        const addedVariantId = addedItem
          ? String(addedItem.variant_id || addedItem.id || '')
          : '';
        if (addedVariantId && addedImageUrl && cartImageStore) {
          cartImageStore.set(addedVariantId, addedImageUrl);
        }

        const mode =
          (window.MegaMacCart &&
            window.MegaMacCart.addToCartFeedbackMode &&
            window.MegaMacCart.addToCartFeedbackMode()) ||
          'drawer';
        if (mode === 'notification') return;
        if (isOnCartPage()) return;
        if (mode !== 'drawer') return;

        let cart = detail.cart;
        if (
          !cart &&
          window.MegaMacCart &&
          typeof window.MegaMacCart.fetchCartAndEmit === 'function'
        ) {
          cart = await window.MegaMacCart.fetchCartAndEmit();
        }
        if (cart) onCartUpdated(cart);

        openCartPanelAt(addedVariantId);
      },
    );
  })();
})();
